



































































import { ConfirmModal } from '@/app/components';
import { XIcon, ChevronLeftIcon } from '@vue-hero-icons/outline';
import { defineComponent, ref, PropType } from '@vue/composition-api';
import { WizardAction } from '../types';

export default defineComponent({
    name: 'WizardActions',
    components: { ConfirmModal, XIcon, ChevronLeftIcon },
    props: {
        backRoute: {
            type: String,
            default: 'home',
        },
        actions: {
            type: Array as PropType<WizardAction[]>,
            required: true,
        },
        showCancel: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        queryParams: {
            type: String,
            default: '{}',
        },
    },
    setup(props: any, { root, emit }: { root: any; emit: any }) {
        const showConfirmCancelModal = ref(false);

        const cancel = () => {
            root.$router.push({ name: props.backRoute, query: JSON.parse(props.queryParams) });
            emit('cancel');
        };

        return { showConfirmCancelModal, cancel };
    },
});
